import React from 'react'
import './HireMeBtn.css'

export default function HireMeBtn({text}) {
    return (
        <div className="hire-me-btn-container">
             <a className="hire-me-btn" href="">{text}</a>
        </div>
    )
}
